import { defaultAgent, apiResponse } from '../helpers/web-agent';
import {
    GET_CREW_LIST_REQUEST, CREW_SUCCESS, CREW_FAILURE, CREW_CLEAR, GET_CREW_LIST, GET_WORK_PLAN,
    GET_CREW_INFO, CLEAR_CREW_LIST, WHATIF_CALCULATE, WHATIF_INFO, UPDATE_CREW_ACTIVE, GET_SELECTED_CREW
} from '../constants/action-types';
import { toastInfo, toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { CREW_CREATED, CREW_EDITED, CREW_DELETED } from '../constants/messages';
import { getSearchDateRange } from '../helpers/common';

export const crewListRequest = () => ({ type: GET_CREW_LIST_REQUEST });

export const crewList = (data, selectedPlanTypeId) => ({ type: GET_CREW_LIST, payload: data, selectedPlanTypeId });

export const selectedCrew = data => ({ type: GET_SELECTED_CREW, payload: data });

export const crewInfo = data => ({ type: GET_CREW_INFO, payload: data });

export const crewFailure = data => ({ type: CREW_FAILURE, payload: data });

export const crewSuccess = () => ({ type: CREW_SUCCESS });

export const crewClear = () => ({ type: CREW_CLEAR });

export const workPlan = data => ({ type: GET_WORK_PLAN, payload: data });

export const clearCrewList = () => ({ type: CLEAR_CREW_LIST });

export const whatIfInfo = data => ({ type: WHATIF_INFO, payload: data });

export const whatIfPlan = data => ({ type: WHATIF_CALCULATE, payload: data });

export const updateActive = data => ({ type: UPDATE_CREW_ACTIVE, payload: data });

export const createCrew = (data, cb = null) => dispatch => {
    defaultAgent.post('/api/crew/add', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === CREW_CREATED.code) {
                if (cb) cb();
                dispatch(toastSuccess(agentResult.message));
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

export const editCrew = (data, cb = null) => dispatch => {
    defaultAgent.put('/api/crew/edit', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === CREW_EDITED.code) {
                if (cb) cb();
                dispatch(toastSuccess(agentResult.message));
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

export const getCrewList = params => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        plan_type_id: params.selectedPlanType
    };

    dispatch(crewListRequest());
    defaultAgent.get('/api/crew/v1/list', reqParams, { requestId: "crewList" })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(crewList());
            } else if (agentResult.data) {
                dispatch(crewList(agentResult.data, params.selectedPlanType));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Crew List: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(crewList());
        });
}

export const deleteCrew = (data, cb) => dispatch => {
    defaultAgent.delete('/api/crew/v1/delete', { crew_uuid: data.crew_uuid, farm_uuid: data.farm_uuid })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === CREW_DELETED.code) {
                dispatch(toastInfo(agentResult.message));
                if (cb) cb();
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

export const getWorkPlan = data => dispatch => {
    defaultAgent.post('/api/crew/workplan', data).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(workPlan());
        } else if (agentResult.data) {
            dispatch(workPlan(agentResult.data));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        dispatch(workPlan());
    });
}

export const getCrewInfo = (farmId, crewId) => dispatch => {
    defaultAgent.get('/api/crew/info', { farm_uuid: farmId, crew_uuid: crewId })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(crewInfo());
            } else if (agentResult.data) {
                dispatch(crewInfo(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(crewInfo());
        });
}

export const getWhatIfInfo = (farmId, crewId) => dispatch => {
    defaultAgent.get('/api/crew/whatif', { farm_uuid: farmId, crew_uuid: crewId })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(whatIfInfo());
            } else if (agentResult.data) {
                const whatIf = agentResult.data;
                const egIds = whatIf.equipment_group_list ? whatIf.equipment_group_list.map(e => e.equipment_group_uuid) : [];

                dispatch(getCrewKPIInfo({ crewId, egIds }, data => {
                    const completedAcres = data && data.completedAcres ? parseFloat(data.completedAcres) : 0;
                    const remainingAcres = whatIf.acres > completedAcres ? parseFloat(whatIf.acres) - completedAcres : 0;
                    whatIf["remaining_acres"] = remainingAcres;
                    dispatch(whatIfInfo(whatIf));
                }));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(whatIfInfo());
        });
}

export const getWhatIfPlan = params => dispatch => {
    defaultAgent.post('/api/crew/whatif', params).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(whatIfPlan());
        } else if (agentResult.data) {
            agentResult.data.graph.isFetching = (agentResult.data.graph.planned.length > 0) ? false : true;
            dispatch(whatIfPlan(agentResult.data));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        dispatch(whatIfPlan());
    });
}

export const getCrewKPIInfo = (params, cb) => dispatch => {
    const dispatchDone = (error, crewId, completedAcres) => {
        if (error) {
            dispatch(toastError(error));
            return cb(null);
        } else return cb({ crewId, completedAcres });
    };

    const reqParams = {
        crew_uuid: params.crewId,
        start_date: params.startDate,
        end_date: params.endDate,
        equipment_group_uuid: params.egIds.join(",")
    };

    defaultAgent.post('/api/equipment/group/kpi/latest', reqParams).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message)
            dispatchDone(agentResult.message);
        else if (agentResult.data) {
            let completedAcres = 0;
            const kpiData = agentResult.data;
            for (const egId in kpiData) {
                if (!(kpiData[egId].data && Array.isArray(kpiData[egId].data))) continue;
                const data = kpiData[egId].data;

                for (const item of data) {
                    completedAcres += item.summary && item.summary.work && !isNaN(item.summary.work.acres) ? item.summary.work.acres : 0;
                }
            }
            dispatchDone(null, params.crewId, completedAcres);
        }
    }).catch(() => {
        dispatchDone(null, params.crewId, 0);
    });
}

export const updateActiveStatus = data => dispatch => {
    dispatch(updateActive({ active: data.active, crew_uuid: data.crew_uuid }));
    defaultAgent.put('/api/crew/active', { active: data.active, crew_uuid: data.crew_uuid })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}